export default "<div class=\"coming-soon\">\n  <p>Les notifications arrivent très bientôt !</p>\n  <p>Restez connecté pour ne pas les manquer.</p>\n</div>\n";